'use client';

import { notFound } from 'next/navigation';
import { useRouter } from 'next/navigation';
import type { RoomView } from '@concept/protocol';
import { GameBoard } from '../../features/game/game-board';

const PREVIEW_ROOM: RoomView = {
  code: 'PLAY',
  mode: 'freestyle',
  phase: 'freestyle',
  version: 1,
  hostPlayerId: '00000000-0000-4000-8000-000000000001',
  players: [
    {
      id: '00000000-0000-4000-8000-000000000001',
      nickname: 'Ada',
      score: 0,
      isHost: true,
      isConnected: true,
    },
    {
      id: '00000000-0000-4000-8000-000000000002',
      nickname: 'Bea',
      score: 0,
      isHost: false,
      isConnected: true,
    },
  ],
  activeClueGiverIds: [
    '00000000-0000-4000-8000-000000000001',
    '00000000-0000-4000-8000-000000000002',
  ],
  board: [
    { id: 'green-pawn', color: 'green', kind: 'pawn', iconId: 'p1-001', order: 1 },
    { id: 'green-cube-1', color: 'green', kind: 'cube', iconId: 'p1-001', order: 2 },
    { id: 'red-pawn', color: 'red', kind: 'pawn', iconId: 'p1-019', order: 3 },
    { id: 'red-cube-1', color: 'red', kind: 'cube', iconId: 'p1-019', order: 4 },
    { id: 'red-cube-2', color: 'red', kind: 'cube', iconId: 'p1-019', order: 5 },
  ],
  boardActivity: [
    {
      id: 1,
      action: 'added',
      actorPlayerId: '00000000-0000-4000-8000-000000000001',
      actorWasClueGiver: true,
      marker: { id: 'green-pawn', color: 'green', kind: 'pawn', iconId: 'p1-001', order: 1 },
      previousIconId: null,
      at: 1,
    },
    {
      id: 2,
      action: 'added',
      actorPlayerId: '00000000-0000-4000-8000-000000000002',
      actorWasClueGiver: true,
      marker: { id: 'red-pawn', color: 'red', kind: 'pawn', iconId: 'p1-019', order: 3 },
      previousIconId: null,
      at: 2,
    },
  ],
  roundNumber: 1,
};

export default function BoardPreviewPage() {
  const router = useRouter();
  if (process.env.NODE_ENV !== 'development') notFound();
  return (
    <GameBoard
      currentPlayerId={PREVIEW_ROOM.players[0]!.id}
      leaveRoomDestination="main menu"
      leaveRoomLabel="Back"
      onLeaveRoom={() => router.push('/')}
      room={PREVIEW_ROOM}
    />
  );
}
